import React from 'react';
import { View } from 'react-native';
import { Feather } from '@expo/vector-icons';

import { useTheme } from '../../theme';

export const STEP_STATUS = {
	DONE: 'done',
	CURRENT: 'current',
	TODO: 'todo',
	BLOCKED: 'blocked',
};

/**
 * StatusIcon: the left status circle of step and stop lists.
 * Props: status ('done' | 'current' | 'todo' | 'blocked'), size (default 24)
 */
const StatusIcon = ({ status, size = 24 }) => {
	const { theme: { ui: { colors } } } = useTheme();
	const ringWidth = size >= 24 ? 2.2 : 2;
	const ringStyle = {
		width: size,
		height: size,
		borderRadius: size / 2,
		borderWidth: ringWidth,
		alignItems: 'center',
		justifyContent: 'center',
	};

	if (status === STEP_STATUS.DONE) {
		return <Feather name="check-circle" size={size} color={colors.success} accessibilityLabel="Done" />;
	}

	if (status === STEP_STATUS.BLOCKED) {
		return <Feather name="lock" size={size - 2} color={colors.textFaint} accessibilityLabel="Locked" />;
	}

	if (status === STEP_STATUS.CURRENT) {
		return (
			<View style={[ringStyle, { borderColor: colors.accent }]} accessibilityLabel="Current">
				<View style={{ width: size / 3, height: size / 3, borderRadius: size / 6, backgroundColor: colors.accent }} />
			</View>
		);
	}

	return <View style={[ringStyle, { borderColor: colors.iconMuted }]} accessibilityLabel="To do" />;
};

export default StatusIcon;
